<template>
  <div v-loading="loading" class="device-plan-library" :class="showUploadDailog ? 'device-plan-library-dialog' : ''">
    <!-- <div class="border_title">
      {{ $t('tianmu.lightLibrary') }}
    </div> -->
    <div class="device-plan-library-container">
      <div
        v-for="item in LibraryList"
        :key="item.Id"
        class="card"
      >
        <img :src="item.Icon" class="card_img" @click="clickCard(item)">
        <div class="card_title" :title="item.Name">
          {{ item.Name }}
          <i 
            v-if="!item.icon_status && isNew"
            class="el-icon-edit edit"
            @click.stop="showLightDialog(item, $event)"
          />
        </div>
        <el-checkbox
          v-if="isEdit"
          v-model="item.ischecked"
          class="card_check"
        />
        
        <img
          v-if="item.icon_status"
          :src="item.icon_status"
          class="icon_status"
          @click.stop="clickCard(item)"
        >
        <div v-if="item.isShowEdit" class="light-edit-dialog" :style="lightEditStyle">
          <div class="main">
            <span class="inputTitle">{{ $t('devicecard.light') + '：' }}</span>
            <div class="light">
              <!-- <OppleTriggerUiCom type="UIControl_Bright" :component-props="{ DefaultValue: 100, Desc: '亮度', }" /> -->
              <UIControl_Bright
                :name="$t('devicecard.light')"
                :value="lightValue"
                :min="1"
                :max="100"
                type="SliderWithInput"
                @change="(value) => {
                  lightValue = value
                }"
              />
            </div>
          </div>
          <div class="light-edit-btnList">
            <OppleButton
              type="default"
              size="mini"
              @click.native.stop="item.isShowEdit = false"
            >
              {{ $t('visual.cancel') }}
            </OppleButton>
            <OppleButton
              size="mini"
              @click.native.stop="handlerEditScene(item)"
            >
              {{ $t('deviceMsg.sure') }}
            </OppleButton>
          </div>
        </div>
      </div>
      <el-upload
        v-if="hasPermission"
        class="card addCard"
        accept="image/*"
        action="xxx"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="onImageChange"
      >
        <img src="@/assets/img/planAdd.png" class="planAdd">
        <span class="addTitle">{{ $t('visual.uploadImg') }}</span>
        <span class="addTip">{{ $t('visual.imgSize') }}≤2000 x 2000，{{ $t('sceneTemplate.limit') }}</span>
      </el-upload>
      <div v-if="hasPermission" class="device-plan-library-container-edit">
        <span v-if="!isEdit" class="modify" @click="modify">{{ $t('base.modify') }}</span>
        <span v-if="isEdit" class="cancel" @click="cancel">{{ $t('base.cancel') }}</span>
        <span v-if="isEdit" class="delete" @click="deletePlan">{{ $t('base.delete') }}</span>
      </div>
    </div>
    <template v-if="showUploadDailog">
      <el-dialog
        :title="$t('visual.uploadImg')"
        :visible.async="showUploadDailog"
        class="uploadDailog"
        :modal-append-to-body="false"
        @close="UploadDailogColse"
        @before-close="UploadDailogColse"
      >
        <div class="uploadDailog_content">
          <img :src="imageUrl" class="planImage">
          <div class="tips">
            <i class="el-icon-warning yellow" />
            <span>{{ $t('tianmu.upImageTip') }}</span>
          </div>
          <div class="tips inputDiv">
            <span class="inputTitle">{{ $t('tianmu.customizeName')+'：' }}</span>
            <el-input
              v-model="planName"
              type="text"
              :placeholder="$t('sylogs.plhode3')"
              class="inputPlan"
              :maxlength="30"
            />
          </div>
          <OppleButton class="addBtn" :disabled="!planName" @click="addPlan">
            {{ $t('projectList.add') }}
          </OppleButton>
        </div>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import { UploadFile } from '@/axios/ICommon.js'
import { alerterror ,warning,alertsuccess} from '@/assets/js/common.js'
import { GetTianMuDevicePlanLibrary, AddPlanSceneLib, DelPlanSceneLib, GetPlanInfoDetail } from '@/axios/IDevice.js'
import { GroupDelete, Create, FindScene, Edit } from '@/axios/IScene.js'
import { Call } from '@/axios/IScene.js'
import TianmuProxy from '@/page/tianmu-design/canvas/CanvasMain/lib/TianmuProxy'
import OppleButton from '@/components/Base/OppleButton/index.vue'
import { AutoSyncBatch } from '@/axios/IDevice.js'
import { isExistPermission } from '@/components/OppleAuth/index.vue'
import { transLightToProp, transLightToValue } from '@/utils/actionsHandler';
import UIControl_Bright from '@/components/button/SliderWithInput.vue'
import {
  FindDevice,
  Finduiability
} from '@/axios/IDevice.js'
import { loadAsyncImg } from '@/components/DesignCanvas/index'

const MAX_IMAGE_SIZE = 3 * 1024 * 1024
const MAX_IMAGE_SIDE = 2000

// 方案类别
export const PLANTYPE = {
  System: 'System', //系统
  Customize: 'Project', // 自定义
}

// 方案状态
export const PLANSTATUS = {
  AllSuccess: 1, //全部成功
  Invalid: 99, //无效
  Overflow: 4, //满了&& 溢出
  Configing: 0, //配置中
  SomeSuccess: 2, //部分成功
  Failure: 3, // 失败
}
export default {
  components: {
    OppleButton,
    UIControl_Bright
  },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    deviceCardList: {
      type: Array,
      default: () => [],
    },
    PlanId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      lightValue: 100,
      showUploadDailog: false, //显示上传弹窗
      imageUrl: '', //本地图片
      cdnUrl: '', // 上传成功后图片
      planName: '', // 方案名称
      loading: false,
      LibraryList: [],
      isEdit: false,
      timr:null,
      hasPermission: isExistPermission('ActionDevice', this.$store.state.isPassPermission),
      industryCode: 1,
      getPlanInfoDetailResult: {},
      isNew: false,
      lightEditStyle: null,
    }
  },

  watch: {
    showUploadDailog(newVal) {
      if (newVal) {
        // 打开弹窗时，给 body 添加 class
        document.body.classList.add('dialog-open-global-style')
      } else {
        document.body.classList.remove('dialog-open-global-style')
        document.body.classList.add('dialog-close-global-style')
      }
      this.$parent && this.$parent.$emit('selectChildDevice', newVal)
    },
    async PlanId(newVal) {
      if (newVal) {
         const { Result } = await this.getPlanInfoDetail({ planId: newVal })
          if (Result) {
            this.getPlanInfoDetailResult = Result
            this.industryCode = Result?.plan_project_info?.industryCode || 1
          }
          this.getPlanLibrary() 

          this.isNew = await this.getIsNew();
      }
    },
  },
  async mounted() {
    try{
       const { Result } = await this.getPlanInfoDetail({ planId: this.PlanId })
        if (Result) {
          this.getPlanInfoDetailResult = Result
          this.industryCode = Result?.plan_project_info?.industryCode || 1
        }

        this.isNew = await this.getIsNew();
    }catch(e){
      console.log(e)
    }
    this.getPlanLibrary()
  },
  destroyed(){
    this.timr && clearTimeout(this.timr)
  },
  methods: {
    async showLightDialog(item, event) {
      const isShowEdit = item.isShowEdit;

      if (isShowEdit === false) {
        // await 前缓存卡片 DOM，避免事件目标失效
        const card = event?.currentTarget?.closest?.('.card');
        const lightInfo =  await this.getSceneLight(item);

        this.lightValue = transLightToProp(lightInfo.value);

        this.LibraryList.forEach(data => {
          if (data !== item) data.isShowEdit = false;
        })

        this.lightEditStyle = this.calcLightEditStyle(card);
      }

      item.isShowEdit = !isShowEdit;
    },

    // 左对齐会超出容器时改为右对齐，避免靠右卡片弹层被裁切
    calcLightEditStyle(card) {
      if (!card) return { left: '0', right: 'auto' };

      const dialogWidth = 400;
      const cardRect = card.getBoundingClientRect();
      const boundaryEl =
        card.closest('.el-dialog') ||
        card.closest('.el-scrollbar__wrap') ||
        card.closest('.have_tree') ||
        document.documentElement;
      const boundaryRight = Math.min(
        boundaryEl.getBoundingClientRect().right,
        window.innerWidth
      );
      // 预留边距，避免贴边仍被 padding/滚动条裁切
      const overflowRight = cardRect.left + dialogWidth > boundaryRight - 24;

      return overflowRight
        ? { left: 'auto', right: '0' }
        : { left: '0', right: 'auto' };
    },
    async getPlanInfoDetail({ planId }){
      if(!planId) return
      const res = await GetPlanInfoDetail({ planId})

      if(res.StatusCode !== this.$store.state.rightStatusCode){
        alerterror(this, res.StatusCode)
        return
      }
      return res
    },
    UploadDailogColse() {
      this.showUploadDailog = false
      this.imageUrl = ''
      this.cdnUrl = ''
      this.planName = ''
    },
    async onImageChange(file) {
      const url = URL.createObjectURL(file.raw)

      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.error(`${this.$t('visual.uploadImg')}${this.$t('lastLight.lessthan')}3M`)
        URL.revokeObjectURL(url)
        return
      }

      const img = await loadAsyncImg(url)

      if (img.width > MAX_IMAGE_SIDE || img.height > MAX_IMAGE_SIDE) {
        this.$message.error(
          `${this.$t('visual.uploadImg')}${this.$t('sceneCard.size')}${this.$t('lastLight.lessthan')}2000 x 2000`
        )
        URL.revokeObjectURL(url)
        return
      }

      const formData = new FormData()
      formData.append('file', file.raw)
      this.loading = true
      UploadFile(formData, res => {
        if (res.StatusCode === this.$store.state.rightStatusCode) {
          const cdnUrl = res?.Result?.RootPath + res?.Result?.FilePath
          this.imageUrl = url
          this.cdnUrl = cdnUrl
          this.showUploadDailog = true
        } else {
          URL.revokeObjectURL(url)
          alerterror(this, res.StatusCode)
        }
        this.loading = false
      })
    },
    //获取方案库
    async getPlanLibrary(showLoading =true) {
      //  Name: null,
      //     Types: null,
      //     PlanId: this.PlanId,
      //     ResourceType: "VIDEO",
      //     PageIndex: 1,
      //     PageSize: 500,
      //     VDeviceId: this.model?.VDeviceId,
      //     ClassSkus: [this.model?.ClassSku],
      //     IndustryCode: this.$store.state.projectinfor.ProjectType,
      //     RoomCode: null,
      //     AppType: 128,
      //     ProductType: 'skyCanvas',
      //     IsIncloudeCustom: true,
      //     OnlyCreated: false
      const param = {
        Types: null,
        PlanId: this.PlanId,
        ResourceType: "IMAGE",
        PageIndex: 1,
        PageSize: 500,
        VDeviceId: this.model?.VDeviceId,
        ClassSkus: [this.model?.ClassSku],
        //IndustryCode: this.industryCode,
        RoomCode: null,
        AppType: 128,
        ProductType: 'skyCanvas',
        IsIncloudeCustom: true,
        OnlyCreated: false
      }
      this.loading = showLoading
      const icon_unConfig = require('@/assets/img/tianmu/unConfig.png')
      const icon_configIng = require('@/assets/img/tianmu/configIng.png')
      const icon_configFailure = require('@/assets/img/tianmu/configFailure.png')
      const icon_overflow = require('@/assets/img/tianmu/overflow.png')

      const iconMap = {
        [PLANSTATUS.AllSuccess]: null,
        [PLANSTATUS.Configing]: icon_configIng,
        [PLANSTATUS.Invalid]: icon_configFailure,
        [PLANSTATUS.Overflow]: icon_overflow,
        [PLANSTATUS.SomeSuccess]: icon_configFailure,
        [PLANSTATUS.Failure]: icon_configFailure,
      }
      const { Result, StatusCode } = await GetTianMuDevicePlanLibrary(param)
      if (StatusCode == this.$store.state.rightStatusCode) {
        this.LibraryList = (Result?.DataList || []).map(item => {
          const { SceneStatus, SceneId } = item
          let icon_status = SceneId === 0 ? icon_unConfig : (iconMap[SceneStatus] || null)
          return {
            ...item,
            ischecked: false,
            icon_status,
            isShowEdit: false,
          }
        })
        const findUn = this.LibraryList.find((item)=>item.SceneStatus === PLANSTATUS.Configing && item.SceneId !== 0)
        if(findUn){
          this.timr && clearTimeout(this.timr)
          this.timr=setTimeout(()=>{
            this.getPlanLibrary(false)
          },10000)
        }
      } else {
        alerterror(this, StatusCode)
      }
      this.loading = false
    },
    //新增方案库
    async addPlan() {
      if(!this.planName) return
      const _param = {
        industryCode: this.industryCode,
        roomCode: 0,
        productType: 'skyCanvas',
        projectCode: this.$store.state.projectinfor.ProjectCode,
        resourceType: 'IMAGE',
        resourceName: this.planName,
        resourceUrl: this.cdnUrl,
      }
      this.loading = true
      const { StatusCode } = await AddPlanSceneLib(_param)
      if (StatusCode == this.$store.state.rightStatusCode) {
        this.UploadDailogColse()
        this.getPlanLibrary()
      } else {
        alerterror(this, StatusCode)
      }
      this.loading = false
    },
    //编辑
    modify() {
      this.isEdit = true
    },
    //取消
    cancel() {
      this.isEdit = false
      this.LibraryList.forEach(item => (item.ischecked = false))
    },
    //删除 效果
    async deletePlan() {
      const list = this.LibraryList.filter(item => item.ischecked)
      if (list.length == 0) return
      //是否自定义效果 自定义效果需要删除资源
      const Customize = list.filter(item => item.TemplateRole === PLANTYPE.Customize)
      if (Customize.length > 0) {
        await this.deleteCustomize(Customize)
      }
      //  过滤已经配置过的场景
      let ids = list.filter(item => item.SceneId !== 0)
      if (ids.length == 0) {
        this.getPlanLibrary()
        this.isEdit = false
        return
      }
      ids = ids.map(item => item.SceneId)
      const { StatusCode } = await GroupDelete(ids)
      if (StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, StatusCode)
        this.getPlanLibrary()
        this.isEdit = false
      } else {
        alerterror(this, StatusCode)
      }
    },
    // 点击卡片
    clickCard(item) {
      if (this.isEdit) {
        item.ischecked = !item.ischecked
        return
      }
      // 无权限
      if(!this.hasPermission){
        return
      }
      const { SceneStatus, SceneId } = item
      // 未配置过场景,点击去下发
      if (SceneId === 0) {
        //去下发场景
        this.createScene(item)
        return
      }
      // 场景下发成功,点击去执行场景
      if (SceneStatus === PLANSTATUS.AllSuccess) {
        // 去执行场景
        this.callAction(item)
        return
      }else if(SceneStatus === PLANSTATUS.Configing ){
        warning(this,this.$t('tianmu.configTip'))
      }else{
        let showTips = true
        if(SceneStatus === PLANSTATUS.Overflow){
          warning(this,this.$t('tianmu.overflowTip'))
          showTips = false
        }
        this.resetAction(showTips)
        return
      }
    },
    // 批量删除自定义
    async deleteCustomize(list) {
      const idList = list.map(item => item.Id)
      const { StatusCode } = await DelPlanSceneLib({ idList })
      if (StatusCode == this.$store.state.rightStatusCode) {
        
      } else {
        alerterror(this, StatusCode)
      }
    },

     async getSceneLight(item) {
      try {
        const res = await FindScene({
          sceneNo: item.SceneId
        });

        const firstDevice = (res.Result?.DeviceList || [])[0] || {};
        const ActionList = firstDevice.ActionList || [];
        const firstValues = (ActionList[0] || {}).Values || [];
        const lightInfo = firstValues.find(item => item.KeyId === 5) || {};

        return {
          min: 0,
          max: 100,
          value: Math.min(255, Number(lightInfo.Value)) || 255
        };
      } catch (error) {
        return {
          min: 0,
          max: 255,
          value: 255
        };
      }     
    },
    async getCurrentLight() {
      try {
        const deviceInfo = await FindDevice({
          vDeviceId: this.model?.VDeviceId,
          channelId: this.model?.ChildId || this.model?.ChannelId,
        });

        const StatusInfo = JSON.parse(deviceInfo.Result?.StatusInfo || '{}');
        const lightInfo = StatusInfo.find(item => item?.StatusType?.startsWith('0x03')) || {};

        return {
          min: lightInfo.Min,
          max: lightInfo.Max,
          value: Number(lightInfo.Value) || 255
        };
      } catch (error) {
        return {
          min: 0,
          max: 255,
          value: 255
        };
      }     
    }, 

    async getIsNew() {
      try {
        const res = await Finduiability({ vDeviceId: this.model?.VDeviceId });

        if (res?.Result?.UIConfigV2?.TianMuVersion === 2) {
          return true;
        }

        return false;
      } catch (error) {
        console.error('getIsNew=====:', error)
      }
    },
    
    // 去下发场景
    async createScene(item) {
      if (!this.PlanId) return
      
      const { Icon, Name, Id } = item
      this.loading = true
      const { Result, StatusCode } = await this.getPlanInfoDetail({ planId: this.PlanId });
      const isNew = await this.getIsNew();

      if (StatusCode == this.$store.state.rightStatusCode) {
        try {
          let tianmuProxy = new TianmuProxy(Result)
          const lightValue = await this.getCurrentLight();
          
          const actionInfo = await tianmuProxy.getSceneData({
            url: Icon,
            deviceList: this.deviceCardList,
            isNew,
            lightValue: lightValue.value
          })
          const param = {
            SceneType: 1,
            GpNo: this.model?.Gpno,
            SecneName: `${this.model?.DeviceName} ${Name}`,
            IconUrl: Icon,
            isFavorite: false,
            WellSkyTemplateId: Id,
            ShowEntry: 1,
            TransportType: 'MatrixScene',
            DeviceList: actionInfo,
            AutoTemplateParams: { DataContent: { isCanEdit: false }  },
          }
          const _res = await Create(param)
          if (_res.StatusCode == this.$store.state.rightStatusCode) {
            this.getPlanLibrary()
            alertsuccess(this, _res.StatusCode)
          } else {
            alerterror(this, _res.StatusCode)
          }
        } catch (error) {
          console.error('createScene=====:', error)
          this.loading = false
        }
      } else {
        alerterror(this, StatusCode)
      }
      this.loading = false
    },

     async handlerEditScene(item) {
       if (!this.PlanId) return
       transLightToValue(this.lightValue)
      
      const { Icon, Name, Id, SceneId } = item;
      this.loading = true;

      const isNew = await this.getIsNew();

      const { Result, StatusCode } = await this.getPlanInfoDetail({ planId: this.PlanId });

      if (StatusCode == this.$store.state.rightStatusCode) {
        try {
          let tianmuProxy = new TianmuProxy(Result)          
          const actionInfo = await tianmuProxy.getSceneData({
            url: Icon,
            deviceList: this.deviceCardList,
            isNew,
            lightValue:  transLightToValue(this.lightValue)
          })
          const param = {
            SceneNo: SceneId,
            SceneType: 1,
            GpNo: this.model?.Gpno,
            SecneName: `${this.model?.DeviceName} ${Name}`,
            IconUrl: Icon,
            isFavorite: false,
            WellSkyTemplateId: Id,
            ShowEntry: 1,
            TransportType: 'MatrixScene',
            DeviceList: actionInfo,
            AutoTemplateParams: { DataContent: { isCanEdit: false }  },
          }
          const _res = await Edit(param)
          if (_res.StatusCode == this.$store.state.rightStatusCode) {
            this.getPlanLibrary()
            alertsuccess(this, _res.StatusCode)
          } else {
            alerterror(this, _res.StatusCode)
          }
        } catch (error) {
          console.error('createScene=====:', error)
          this.loading = false
        }
      } else {
        alerterror(this, StatusCode)
      }
      this.loading = false
    },


    // 去执行场景
    async callAction(item) {
      const { SceneId } = item
      if (SceneId !== 0) {
        const { StatusCode } = await Call({ sceneNo: SceneId })

        if (StatusCode == this.$store.state.rightStatusCode) {
          alertsuccess(this, StatusCode)
        } else {
          alerterror(this, StatusCode)
        }
      }
    },
    // 重试下发
    async resetAction(showTips = true) {
       const VDeviceIds = this.deviceCardList.map(device => device.VDeviceId)
       const { StatusCode } = await AutoSyncBatch({VDeviceIds })
        if (StatusCode == this.$store.state.rightStatusCode) {
          showTips && alertsuccess(this, StatusCode)
          this.getPlanLibrary()
        } else {
          showTips && alerterror(this, StatusCode)
        }
    },
    // 获取是否有权限
    getDeviceOption() {
      const code = 'tianmu_plan_library'
      const isPassPermission = this.$store.state.isPassPermission
      if (isExistPermission(code, isPassPermission)) {
        return true
      } else {
        return false
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.edit {
  display: block;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  color: #0211fd;
  text-align: center;
  line-height: 18px;
  background-color: #fff;
}
.light-edit-dialog {
  position: absolute;
  width: 400px;
  height: 120px;
  background-color: #fff;
  bottom: -120px;
  left: 0;
  z-index: 9999;
  box-shadow: 3px 5px 25px 0px rgba(64, 64, 64, 0.22);
  border-radius: 4px;

  .main {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    .light {
      width: 300px;
    }
  }

  .light-edit-btnList {
    display: flex;
    justify-content: center;
    align-items: center;
    
    &>:first-child {
      margin-right: 8px;
    }
  }
}

.device-plan-library {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .device-plan-library-container {
    display: flex;
    width: 100%;
    flex-direction: row;
    //border: 1px solid #e0e3e6;
    box-sizing: border-box;
    padding: 40px;
    flex-wrap: wrap;
    position: relative;
    .card {
      width: 180px;
      height: 180px;
      border-radius: 5px;
      position: relative;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;
      .card_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }
      .card_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        height: 30px;
        background-color: rgba(0, 0, 0, 0.4);
        line-height: 30px;
        color: #ffffff;
        padding: 0px 10px;
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 隐藏溢出文字 */
        text-overflow: ellipsis;
      }
      .card_check {
        position: absolute;
        top: 5px;
        right: 5px;
      }
      .icon_status {
        width: 34px;
        height: 34px;
        position: absolute;
        left: 73px;
        top: 58px;
      }
    }
    .addCard {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #000000;
      background: #f7f7f7;
      flex-direction: column;
      .planAdd {
        width: 20px;
        height: 20px;
      }
      .addTitle {
        font-size: 12px;
        color: #000000;
        line-height: 20px;
        margin-top: 5px;
      }
      .addTip {
        max-width: 150px;
        color: #777777;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
      }
    }
    .device-plan-library-container-edit {
      position: absolute;
      right: 20px;
      top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .modify {
        color: #3f9efe;
        cursor: pointer;
      }
      .cancel {
        color: #3f9efe;
        margin-right: 10px;
        cursor: pointer;
      }
      .delete {
        color: #ff4000;
        cursor: pointer;
      }
    }
  }
}
.addCard ::v-deep .el-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.uploadDailog {
  width: 100%;
  height: 100%;
}
.uploadDailog ::v-deep .el-dialog {
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  overflow: scroll;
}
.uploadDailog ::v-deep .el-dialog__header {
  background: #2145a4;
  border-radius: 8.53px 8.53px 0px 0px;
  .el-dialog__title {
    color: #ffffff;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
  }
}

.uploadDailog_content {
  width: 100%;
  height: 100%;
  padding: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  flex-direction: column;
  .planImage {
    width: 400px;
    height: 250px;
    object-fit: cover;
  }
  .tips {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    flex-direction: row;
    span {
      color: #3d3d3d;
      font-size: 15px;
    }
    .inputTitle {
      color: #333333;
      font-weight: 600;
      font-size: 13px;
      margin-right: 10px;
    }
    .yellow {
      color: rgba(255, 178, 0, 1);
      font-size: 15px;
      margin-right: 3px;
    }
    .inputPlan {
      width: 360px;
    }
  }
  .inputDiv {
    margin-top: 50px;
  }
  .addBtn {
    margin-top: 80px;
    padding: 0px 64px;
    background: #2145a4;
    border-radius: 6px;
    font-size: 19px;
    color: #fff;
    line-height: 40px;
    height: 40px;
    text-align: center;
  }
  .disable {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>

<style lang="css">
.dialog-open-global-style .v-modal {
  display: none !important;
}
.dialog-close-global-style .device-plan-library .v-modal {
  display: none !important;
}
</style>
